import * as React from 'react';
import './assessRiskProfile.style.css';
import { TQuestionData } from '../models/riskQuestion.model';
import 'bootstrap/dist/css/bootstrap.min.css';

export interface IAssessRisk {
  /* Slide Number: 1, maximumDecline: 2, stockMarketForecast: 3, ageRange: 4, plannedWithdrawal: 5 */
  currentRiskSequence: number;
  /** */
  investmentAmount: number;
  /** */
  investmentInfo: TQuestionData;
  /** */
  maximumDecline: TQuestionData;
  /** */
  stockMarketForecast: TQuestionData;
  /** */
  ageRange: TQuestionData;
  /** */
  plannedWithdrawal: TQuestionData;
}

export interface IAssessRiskProfileState {
  riskSequence: number;
}

export interface IAssessRiskProfileProps {
  /** Next button click event handler */
  onNextButtonClick: (event: any, data: IAssessRisk) => void;
  /** Back button click event handler */
  onBackButtonClick: (event: any, data: IAssessRisk) => void;
  /** Skip button click event handler */
  onSkipButtonClick?: (event: any, data: IAssessRisk) => void;
  /** */
  backButtonText: string;
  /** */
  nextButtonText: string;
  /** */
  skipButtonText: string;
  /** */
  data: IAssessRisk;
}

export class AssessRiskProfileComponent extends React.Component<
  IAssessRiskProfileProps,
  IAssessRiskProfileState
> {
  constructor(props?: IAssessRiskProfileProps, context?: any) {
    super(props, context);
    this.state = {
      riskSequence: this.props.data.currentRiskSequence
        ? this.props.data.currentRiskSequence
        : 1,
    };
  }

  public handleNextClick_InvestmentInfo(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.investmentInfo = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 2 });
  }

  public handleNextClick_maximumDecline(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.maximumDecline = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 3 });
  }

  public handleNextClick_stockMarketForecast(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.stockMarketForecast = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 4 });
  }

  public handleNextClick_ageRange(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.ageRange = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 5 });
  }

  public handleNextClick_plannedWithdrawal(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.plannedWithdrawal = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 6 });
  }

  public handleBackClick_InvestmentInfo(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.investmentInfo = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 0 });
  }

  public handleBackClick_maximumDecline(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.maximumDecline = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 1 });
  }

  public handleBackClick_stockMarketForecast(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.stockMarketForecast = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 2 });
  }

  public handleBackClick_ageRange(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.ageRange = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 3 });
  }

  public handleBackClick_plannedWithdrawal(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.plannedWithdrawal = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 4 });
  }

  public handleSkipClick_InvestmentInfo(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.investmentInfo = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 1 });
  }

  public handleSkipClick_maximumDecline(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.maximumDecline = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 2 });
  }

  public handleSkipClick_stockMarketForecast(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.stockMarketForecast = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 3 });
  }

  public handleSkipClick_ageRange(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.ageRange = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 4 });
  }

  public handleSkipClick_plannedWithdrawal(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.plannedWithdrawal = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 5 });
  }

  public render() {
    return (
      <div className="jumbotron">
        <div className="display-4">Welcome to Assess Risk Component!</div>
        <hr className="my-4" />
        {this.state.riskSequence && this.state.riskSequence === 1 && (
          <div>
            <div className="alert alert-primary">
              InvestmentInfo component will be rendred...
            </div>
            <div>
              Risk Component Sequence: {this.props.data.currentRiskSequence}
            </div>
            <div>Investment Amount: {this.props.data.investmentAmount}</div>
          </div>
        )}
        {this.state.riskSequence && this.state.riskSequence === 2 && (
          <div>
            <div className="alert alert-primary">
              maximumDecline component will be rendred...
            </div>
            <div>
              Risk Component Sequence: {this.props.data.currentRiskSequence}
            </div>
            <div>Investment Amount: {this.props.data.investmentAmount}</div>
          </div>
        )}
        {this.state.riskSequence && this.state.riskSequence === 3 && (
          <div>
            <div className="alert alert-primary">
              stockMarketForecast component will be rendred...
            </div>
            <div>
              Risk Component Sequence: {this.props.data.currentRiskSequence}
            </div>
            <div>Investment Amount: {this.props.data.investmentAmount}</div>
          </div>
        )}
        {this.state.riskSequence && this.state.riskSequence === 4 && (
          <div>
            <div className="alert alert-primary">
              {' '}
              ageRange component will be rendred...
            </div>
            <div>
              Risk Component Sequence: {this.props.data.currentRiskSequence}
            </div>
            <div>Investment Amount: {this.props.data.investmentAmount}</div>
          </div>
        )}
        {this.state.riskSequence && this.state.riskSequence === 5 && (
          <div>
            <div className="alert alert-primary">
              plannedWithdrawal component will be rendred...
            </div>
            <div>
              Risk Component Sequence: {this.props.data.currentRiskSequence}
            </div>
            <div>Investment Amount: {this.props.data.investmentAmount}</div>
          </div>
        )}
      </div>
    );
  }
}
